import { useAuthStore } from '@/features/auth/store';

export const ASSISTANT_VIEW_PERMISSION = 'portal:assistant:view';
export const ASSISTANT_AVATAR_PERMISSION = 'portal:assistant:avatars';

/** Assistant access requires explicit grants; generic admin roles do not bypass them. */
export function useAssistantAccess() {
  const authenticated = useAuthStore((state) => state.isAuthenticated);
  const user = useAuthStore((state) => state.user);
  const permissions = new Set([...(user?.roles ?? []), ...(user?.permissions ?? [])]);
  const canViewAssistant = authenticated && permissions.has(ASSISTANT_VIEW_PERMISSION);
  return {
    canViewAssistant,
    canUseAssistantAvatars: canViewAssistant && permissions.has(ASSISTANT_AVATAR_PERMISSION),
  };
}
